var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeoperl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlns: "http://www.w3.org/2000/svg",
    height: "76.52pt",
    width: "120.47pt",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120.46875 76.51953",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "g",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "f",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.348 739.27h120.47v55.727h-120.47z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.59 -878.92)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-383.93 139.64)",
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.582 794.51c33.266 0 60.238-9.0078 60.238-27.371s-26.973-27.859-60.238-27.859c-33.27 0-60.234 9.4961-60.234 27.859s26.965 27.371 60.234 27.371",
    fill: "#eb1c23"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-250.2 899.85h-0.51172v0.96094h0.51172c0.30469 0 0.51953-0.20313 0.51953-0.47656 0-0.27735-0.21484-0.48438-0.51953-0.48438m0.53515 2.4062-0.63281-1.1211h-0.41406v1.1211h-0.37891v-2.7461h0.9336c0.47656 0 0.86718 0.35937 0.86718 0.82422 0 0.39843-0.25 0.64843-0.58984 0.7539l0.65625 1.168zm-0.60937-3.5117c-1.1641 0-2.1094 0.96485-2.1094 2.1445 0 1.1758 0.94532 2.1406 2.1094 2.1406 1.1602 0 2.1133-0.96485 2.1133-2.1406 0-1.1797-0.95312-2.1445-2.1133-2.1445m0 4.6524c-1.3867 0-2.5117-1.125-2.5117-2.5078 0-1.3906 1.125-2.5117 2.5117-2.5117 1.3828 0 2.5078 1.1211 2.5078 2.5117 0 1.3828-1.125 2.5078-2.5078 2.5078m-8.0352 11.141v-16.023h2.4297v13.84h7.7148v2.1836zm-8.5859-13.84h-3.5977v5.0195h3.5977c1.6211 0 2.7266-0.92578 2.7266-2.5s-1.1055-2.5195-2.7266-2.5195m2.8125 13.84-3.375-6.7539h-3.0352v6.7539h-2.4336v-16.023h6.2148c3.0352 0 4.9727 1.957 4.9727 4.6797 0 2.2969-1.3984 3.7617-3.1992 4.2539l3.6914 7.0898zm-21.547 0v-16.023h10.238v2.1836h-7.8086v4.6797h6.6641v2.1641h-6.6641v4.8125h7.8086v2.1836zm-7.4102-13.84h-3.5117v5.332h3.5117c1.6875 0 2.8359-0.96485 2.8359-2.6562 0-1.6875-1.1484-2.6758-2.8359-2.6758m0.13282 7.5391h-3.6445v6.3008h-2.4297v-16.023h6.0742c3.1289 0 5.1328 2.0703 5.1328 4.8594 0 2.793-2.0039 4.8633-5.1328 4.8633m-12.707-6.6836c-0.5625-0.60938-1.4414-0.98829-2.3828-0.98829-0.94531 0-1.8242 0.37891-2.3867 0.98829-0.78906 0.85546-0.94531 1.7539-0.94531 4.9726 0 3.2188 0.15625 4.1172 0.94531 4.9727 0.5625 0.60937 1.4414 0.99219 2.3867 0.99219 0.94141 0 1.8203-0.38282 2.3828-0.99219 0.78906-0.85547 0.94921-1.7539 0.94921-4.9727s-0.16015-4.1172-0.94921-4.9726m1.8476 11.406c-1.1055 1.1055-2.5195 1.7109-4.2305 1.7109-1.7109 0-3.1055-0.60547-4.2109-1.7109-1.5742-1.5703-1.5508-3.3516-1.5508-6.4336s-0.0234-4.8633 1.5508-6.4336c1.1055-1.1055 2.5-1.7148 4.2109-1.7148s3.125 0.60938 4.2305 1.7148c1.5742 1.5703 1.5274 3.3516 1.5274 6.4336s0.0469 4.8633-1.5274 6.4336m-22.195 1.5781v-16.023h10.238v2.1836h-7.8086v4.6797h6.6641v2.1641h-6.6641v4.8125h7.8086v2.1836zm-5.8672 0-7.4023-11.273v11.273h-2.4297v-16.023h2.2266l7.4024 11.25v-11.25h2.4297v16.023h-2.2266",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m-339.58 947.23v5.4688h-1.3281v-5.4688h-0.75391v-1.0156h0.75391v-1.0156c0-0.94921 0.57031-1.832 1.8086-1.832h0.83203v1.1289h-0.58594c-0.49609 0-0.72656 0.28906-0.72656 0.76953v0.94922h1.3125v1.0156h-1.3125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-335.34 952.69c-1.2617 0-1.8086-0.84765-1.8086-1.8242v-7.4453h1.3281v7.3672c0 0.50781 0.18359 0.76953 0.71484 0.76953h0.58594v1.1328h-0.82031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-330.09 947.58c-0.25-0.25-0.58984-0.37891-0.97656-0.37891-0.39453 0-0.71875 0.12891-0.96485 0.37891-0.40625 0.40234-0.45703 1.0938-0.45703 1.8086 0 0.71875 0.0508 1.4062 0.45703 1.8086 0.2461 0.25 0.57032 0.39063 0.96485 0.39063 0.38672 0 0.72656-0.14063 0.97656-0.39063 0.40234-0.40234 0.45312-1.0898 0.45312-1.8086 0-0.71484-0.0508-1.4062-0.45312-1.8086m1 4.4141c-0.42969 0.44141-1.082 0.78125-1.9766 0.78125-0.90235 0-1.5391-0.33984-1.9648-0.78125-0.625-0.65234-0.78125-1.4844-0.78125-2.6055 0-1.1055 0.15625-1.9375 0.78125-2.5898 0.42578-0.44141 1.0625-0.78125 1.9648-0.78125 0.89453 0 1.5469 0.33984 1.9766 0.78125 0.625 0.65234 0.78125 1.4844 0.78125 2.5898 0 1.1211-0.15625 1.9531-0.78125 2.6055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-320.36 952.69h-1.1328l-1.5469-4.6094-1.5352 4.6094h-1.1484l-2.043-6.6016h1.4062l1.2773 4.6484 1.5352-4.6484h1.0273l1.5234 4.6484 1.2773-4.6484h1.418z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-318.14 954.71v-3.5273h1.5078v2.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-310.67 952.77c-1.082 0-1.9922-0.18359-2.7734-0.95313l0.875-0.87109c0.53125 0.54688 1.2461 0.69141 1.8984 0.69141 0.80859 0 1.4453-0.28907 1.4453-0.91016 0-0.44531-0.24609-0.73047-0.88281-0.78516l-1.0586-0.0898c-1.2344-0.10156-1.9492-0.66406-1.9492-1.8203 0-1.2891 1.1055-2.0195 2.4844-2.0195 0.98828 0 1.8359 0.20703 2.4492 0.74218l-0.83203 0.84766c-0.41797-0.35156-1.0039-0.48437-1.6289-0.48437-0.79687 0-1.1992 0.35546-1.1992 0.84765 0 0.39063 0.21094 0.6875 0.91016 0.75781l1.043 0.0899c1.2344 0.10156 1.9648 0.6875 1.9648 1.8594 0 1.3789-1.168 2.0977-2.7461 2.0977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-304.64 952.69c-1.2383 0-1.8086-0.88671-1.8086-1.8359v-3.6328h-0.75391v-1.0156h0.75391v-2.0039h1.3242v2.0039h1.2773v1.0156h-1.2773v3.5664c0 0.48047 0.23828 0.76953 0.73047 0.76953h0.54687v1.1328h-0.79297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-299.16 947.58c-0.24609-0.25-0.58594-0.37891-0.97656-0.37891-0.39063 0-0.71485 0.12891-0.96485 0.37891-0.40234 0.40234-0.45312 1.0938-0.45312 1.8086 0 0.71875 0.0508 1.4062 0.45312 1.8086 0.25 0.25 0.57422 0.39063 0.96485 0.39063 0.39062 0 0.73047-0.14063 0.97656-0.39063 0.40234-0.40234 0.45703-1.0898 0.45703-1.8086 0-0.71484-0.0547-1.4062-0.45703-1.8086m1.0039 4.4141c-0.42969 0.44141-1.082 0.78125-1.9805 0.78125-0.89844 0-1.5352-0.33984-1.9648-0.78125-0.625-0.65234-0.78125-1.4844-0.78125-2.6055 0-1.1055 0.15625-1.9375 0.78125-2.5898 0.42969-0.44141 1.0664-0.78125 1.9648-0.78125 0.89844 0 1.5508 0.33984 1.9805 0.78125 0.625 0.65234 0.78125 1.4844 0.78125 2.5898 0 1.1211-0.15625 1.9531-0.78125 2.6055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-293.4 947.2c-1.1992 0-1.3789 1.0156-1.3789 2.1875s0.17969 2.1992 1.3789 2.1992 1.3672-1.0273 1.3672-2.1992-0.16797-2.1875-1.3672-2.1875m1.9531 4.9883c-0.36328 0.36328-0.9375 0.58594-1.6016 0.58594-0.70312 0-1.2461-0.18359-1.7305-0.75781v3.3476h-1.3281v-9.2695h1.3008v0.70313c0.49609-0.59766 1.0273-0.78125 1.7461-0.78125 0.66407 0 1.25 0.22265 1.6133 0.58593 0.66407 0.66407 0.74219 1.7852 0.74219 2.7852 0 1.0039-0.0781 2.1367-0.74219 2.8008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-249.7 944.24h-0.40625v0.76562h0.40625c0.24219 0 0.41407-0.16015 0.41407-0.3789 0-0.22266-0.17188-0.38672-0.41407-0.38672m0.42579 1.9141-0.5-0.89062h-0.33204v0.89062h-0.30078v-2.1836h0.74219c0.37891 0 0.6875 0.28906 0.6875 0.65625 0 0.3164-0.19922 0.51562-0.46875 0.59765l0.52344 0.92969zm-0.48438-2.7852c-0.92578 0-1.6719 0.76171-1.6719 1.6953s0.74609 1.6953 1.6719 1.6953c0.92188 0 1.6758-0.76172 1.6758-1.6953 0-0.9336-0.7539-1.6953-1.6758-1.6953m0 3.6836c-1.1016 0-1.9883-0.88672-1.9883-1.9883 0-1.0977 0.88672-1.9883 1.9883-1.9883 1.0977 0 1.9883 0.89062 1.9883 1.9883 0 1.1016-0.89062 1.9883-1.9883 1.9883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-283.36 949.78h-1.5508c-0.77734 0-1.1836 0.35156-1.1836 0.95312 0 0.59766 0.37891 0.93359 1.2109 0.93359 0.50781 0 0.88281-0.0351 1.2383-0.375 0.19531-0.19531 0.28516-0.50781 0.28516-0.97656zm0.0273 2.918v-0.60156c-0.48438 0.48438-0.94141 0.67969-1.7617 0.67969-0.81641 0-1.3633-0.19531-1.7695-0.60156-0.33594-0.35157-0.51953-0.85938-0.51953-1.418 0-1.1055 0.76953-1.8984 2.2812-1.8984h1.7422v-0.46875c0-0.83594-0.41797-1.2383-1.4453-1.2383-0.73047 0-1.082 0.16797-1.4453 0.64062l-0.8711-0.82421c0.625-0.72657 1.2734-0.94922 2.3672-0.94922 1.8125 0 2.7227 0.76953 2.7227 2.2656v4.4141h-1.3008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-276.54 952.69v-4.0234c0-1.0274-0.58593-1.4727-1.3281-1.4727-0.74219 0-1.3672 0.45703-1.3672 1.4727v4.0234h-1.3281v-6.6016h1.3008v0.66406c0.45703-0.49218 1.0938-0.74218 1.7578-0.74218 0.67578 0 1.2344 0.22265 1.6289 0.59765 0.50781 0.4961 0.66406 1.1211 0.66406 1.8633v4.2188h-1.3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-271.19 947.2c-1.1992 0-1.3828 1.0117-1.3828 2.1875 0 1.1719 0.18359 2.1992 1.3828 2.1992 1.1953 0 1.3633-1.0274 1.3633-2.1992 0-1.1758-0.16797-2.1875-1.3633-2.1875m1.3906 5.4922v-0.70312c-0.4961 0.60156-1.0274 0.78125-1.7461 0.78125-0.66406 0-1.2461-0.21875-1.6133-0.58594-0.66406-0.66406-0.74219-1.7969-0.74219-2.7969 0-1.0039 0.0781-2.125 0.74219-2.7891 0.36719-0.36328 0.9375-0.58203 1.6016-0.58203 0.70313 0 1.25 0.16797 1.7305 0.73828v-3.3281h1.3281v9.2656h-1.3008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-262.06 947.2c-1.1992 0-1.3555 1.0312-1.3555 2.0742 0 1.0391 0.15625 2.0664 1.3555 2.0664 1.1953 0 1.3398-1.0274 1.3398-2.0664 0-1.043-0.14453-2.0742-1.3398-2.0742m-0.15625 8.2422c-1.0078 0-1.6406-0.23438-2.332-0.8711l0.84765-0.84765c0.41406 0.39062 0.78125 0.58594 1.4297 0.58594 1.1211 0 1.5508-0.79297 1.5508-1.6797v-0.84375c-0.48047 0.57031-1.0273 0.7539-1.707 0.7539-0.66406 0-1.2109-0.22265-1.5742-0.58593-0.63672-0.64063-0.74219-1.5625-0.74219-2.6797 0-1.1211 0.10547-2.0469 0.74219-2.6836 0.36328-0.36719 0.92188-0.57422 1.5859-0.57422 0.70312 0 1.2383 0.18359 1.7305 0.78125v-0.70313h1.293v6.5625c0 1.6133-1.0703 2.7852-2.8242 2.7852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-254.42 947.58c-0.25-0.25-0.58985-0.37891-0.98047-0.37891-0.38672 0-0.71484 0.12891-0.96094 0.37891-0.40234 0.40234-0.45312 1.0938-0.45312 1.8086 0 0.71875 0.0508 1.4062 0.45312 1.8086 0.2461 0.25 0.57422 0.39063 0.96094 0.39063 0.39062 0 0.73047-0.14063 0.98047-0.39063 0.40234-0.40234 0.45703-1.0898 0.45703-1.8086 0-0.71484-0.0547-1.4062-0.45703-1.8086m1 4.4141c-0.42969 0.44141-1.082 0.78125-1.9805 0.78125-0.89453 0-1.5312-0.33984-1.9648-0.78125-0.6211-0.65234-0.78125-1.4844-0.78125-2.6055 0-1.1055 0.16015-1.9375 0.78125-2.5898 0.43359-0.44141 1.0703-0.78125 1.9648-0.78125 0.89844 0 1.5508 0.33984 1.9805 0.78125 0.625 0.65234 0.78515 1.4844 0.78515 2.5898 0 1.1211-0.16015 1.9531-0.78515 2.6055"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    height: "100%",
    width: "100%",
    y: 643.84161,
    x: 611.77582
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    height: "100%",
    width: "100%",
    y: 639.09412,
    x: 611.77582
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    height: "100%",
    width: "100%",
    y: 769.09808,
    x: 507.76291
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    height: "100%",
    width: "100%",
    y: 780.09613,
    x: 501.42419
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    height: "100%",
    width: "100%",
    y: 791.09412,
    x: 474.543
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    height: "100%",
    width: "100%",
    y: 791.09412,
    x: 571.32092
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    height: "100%",
    width: "100%",
    y: 29.141701,
    x: 1431.6777
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    height: "100%",
    width: "100%",
    y: 29.141701,
    x: 1438.0173
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    height: "100%",
    width: "100%",
    y: 41.976398,
    x: 1548.9373
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    height: "100%",
    width: "100%",
    y: 478.90439,
    x: 1289.1869
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    height: "100%",
    width: "100%",
    y: 478.90439,
    x: 1293.4109
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    height: "100%",
    width: "100%",
    y: 709.17651,
    x: 1334.8492
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    height: "100%",
    width: "100%",
    y: 709.17651,
    x: 1338.9293
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    height: "100%",
    width: "100%",
    y: 341.84851,
    x: 1318.8749
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    height: "100%",
    width: "100%",
    y: 341.84851,
    x: 1322.7148
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    height: "100%",
    width: "100%",
    y: 72.328499,
    x: 1289.1869
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    height: "100%",
    width: "100%",
    y: 72.328499,
    x: 1293.4109
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    height: "100%",
    width: "100%",
    y: 451.18451,
    x: 1319.5309
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    height: "100%",
    width: "100%",
    y: 451.18451,
    x: 1323.3708
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeoperl);
export default __webpack_public_path__ + "static/media/neoperl.51a88f78bad40fc5cf75e8900c526558.svg";
export { ForwardRef as ReactComponent };